import { reduce } from 'ramda';
import { FETCH_SIDE_BY_SIDE } from '../constants';

const blockedTimes = (state = {}, action) => {
  switch (action.type) {
    case FETCH_SIDE_BY_SIDE:
      return reduce((acc, barber) => {
        acc[barber.id] = barber.blockedTimes;
        return acc;
      }, {}, action.payload.barbers);
    default:
      return state;
  }
};

export default blockedTimes;
